module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange-dcb1164201c5fdd172db6f5e6c564fe6.png";